export default class ShareJourneyViewModel {
    public headline: string;
    public text: string;
    public imageUrl: string;
}
